import downloadButtonTemplate from './button/button.html';
import downloadLinkTemplate from './link/link.html';
import downloadLabelTemplate from './label/label.html';

class DownloadElementController {
  constructor(gettextCatalog) {
    this.title = this.title ? gettextCatalog.getString(this.title) : gettextCatalog.getString('Download');
    this.showProgress = false;
    return this;
  }

  callDownload() {
    this.downloadResult = this.downloadFunction();
    if (this.downloadResult && this.downloadResult.promise) {
      this.showProgress = true;

      this.downloadResult.promise
        .then(
          () => {
            this.showProgress = false;
          },
          () => {
            this.showProgress = false;
          }
        )
        .then(() => {
          if (this.callbackFunction) {
            this.callbackFunction();
          }
        });
    }
  }

  cancelDownload() {
    this.showProgress = false;

    if (this.downloadResult.cancel) {
      this.downloadResult.cancel();
    }
  }
}

DownloadElementController.$inject = ['gettextCatalog'];

export class DownloadElementButtonComponent {
  constructor() {
    this.bindings = {
      title: '@',
      downloadFunction: '&',
      callbackFunction: '&?',
    };
    this.controller = DownloadElementController;
    this.template = downloadButtonTemplate;
    return this;
  }
}

export class DownloadElementLinkComponent {
  constructor() {
    this.bindings = {
      title: '@',
      downloadFunction: '&',
      callbackFunction: '&?',
      additionalClasses: '@?',
    };
    this.controller = DownloadElementController;
    this.template = downloadLinkTemplate;
    return this;
  }
}

export class DownloadElementLabelComponent {
  constructor() {
    this.bindings = {
      title: '@',
      downloadFunction: '&',
      callbackFunction: '&?',
      progressTitle: '@?',
    };
    this.controller = DownloadElementController;
    this.template = downloadLabelTemplate;
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/modules/utils/download-element/download-element-component.js